import MainView from "./MainView";
import FlixContainer from './FlixContainer';
import MainHeader from './MainHeader';

export default {
    MainView,
    MainHeader,
    FlixContainer
}